import React, { useState, useEffect, useRef, useCallback } from "react";
import "../../assets/css/botompanel.css";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getMenuService } from "../header/service/MenuService";
import {
  getCartCount,
  getPreCartCount,
} from "../header/service/CartCount.service";

import {
  setCartCount,
  setPreCartCount,
} from "../../features/Cart/redux/cartSlice";

import { getProductUrl } from "../../utils/url.utils";
import { getProfile } from "../header/service/profileService";

function BottomPanel() {
  const dispatch = useDispatch();

  const wishlistCount = useSelector(
    (state) => state.wishlist?.wishlistCount || 0
  );



  const [activeTab, setActiveTab] = useState("home");
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [expandedSub, setExpandedSub] = useState(null);
  const [categories, setCategories] = useState([]);
  const [searchText, setSearchText] = useState({});
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [profile, setProfile] = useState(null);

  const searchInputRef = useRef(null);
  const accountRef = useRef(null);

  /* ============================================================
     USER DATA
  ============================================================ */

  /* ============================================================
     LOGIN
  ============================================================ */

  useEffect(() => {
    const token =
      localStorage.getItem("access_token") ||
      localStorage.getItem("token");

    setIsLoggedIn(!!token);
  }, []);

  /* ============================================================
     LOGOUT
  ============================================================ */

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    localStorage.removeItem("customerId");
    localStorage.removeItem("userId");
    localStorage.removeItem("cartType");
    localStorage.removeItem("otpLogin");

    dispatch(setCartCount(0));
    dispatch(setPreCartCount(0));

    setIsLoggedIn(false);
    setAccountMenuOpen(false);

    window.location.href = "/";
  };

  /* ============================================================
     PROFILE
  ============================================================ */

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getProfile();

        if (data?.success) {
          setProfile(data.data);
        }
      } catch (error) {
        console.error(
          "Profile API Error:",
          error
        );
      }
    };

    fetchProfile();
  }, []);

  const roleId = Number(
    profile?.user_role_id
  );

  const showQrCodeScan =
    roleId === 5;

  /* ============================================================
     MENU API
  ============================================================ */

  useEffect(() => {
    const loadMenu = async () => {
      try {
        const res = await getMenuService();

        setCategories(
          Array.isArray(res) ? res : []
        );
      } catch (error) {
        console.error(
          "Menu API Error:",
          error
        );

        setCategories([]);
      }
    };

    loadMenu();
  }, []);

  /* ============================================================
     ACCOUNT OUTSIDE CLICK
  ============================================================ */

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        accountRef.current &&
        !accountRef.current.contains(event.target)
      ) {
        setAccountMenuOpen(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };
  }, []);

  /* ============================================================
     NORMALIZE COUNT
     
     API response kisi bhi structure me aaye,
     count yahan se safely niklega.
  ============================================================ */

  const extractCount = useCallback((response) => {
    const count =
      response?.count ??
      response?.cart_count ??
      response?.total_items ??
      response?.data?.count ??
      response?.data?.cart_count ??
      response?.data?.total_items ??
      response?.data?.data?.count ??
      response?.data?.data?.cart_count ??
      response?.data?.data?.total_items ??
      0;

    const parsedCount = Number(count);

    return Number.isFinite(parsedCount)
      ? parsedCount
      : 0;
  }, []);

  /* ============================================================
     LOAD BOTH CART COUNTS
     
     IMPORTANT:
     Fresh Cart    -> getCartCount()
     Coming Soon   -> getPreCartCount()
     
     Dono alag Redux state me jayenge.
  ============================================================ */

  const syncAllCartCounts = useCallback(
    async () => {
      const currentUserId =
        Number(
          localStorage.getItem("userId")
        ) || 1;

      const currentCustomerId =
        Number(
          localStorage.getItem("customerId")
        ) || 0;

      try {
        const [freshResult, preResult] =
          await Promise.allSettled([
            getCartCount(
              "fresh",
              currentUserId,
              currentCustomerId || null
            ),

            getPreCartCount(
              "pre",
              currentUserId,
              currentCustomerId || null
            ),
          ]);

        /* ======================================================
           FRESH CART COUNT
        ====================================================== */

        if (
          freshResult.status === "fulfilled"
        ) {
          const freshCount =
            extractCount(
              freshResult.value
            );

          dispatch(
            setCartCount(
              freshCount
            )
          );
        } else {
          console.error(
            "Fresh Cart Count Error:",
            freshResult.reason
          );
        }

        /* ======================================================
           COMING SOON CART COUNT
        ====================================================== */

        if (
          preResult.status === "fulfilled"
        ) {
          const preCount =
            extractCount(
              preResult.value
            );

          dispatch(
            setPreCartCount(
              preCount
            )
          );
        } else {
          console.error(
            "Pre Cart Count Error:",
            preResult.reason
          );
        }

      } catch (error) {
        console.error(
          "Cart Count Sync Error:",
          error
        );
      }
    },
    [dispatch, extractCount]
  );

  /* ============================================================
     INITIAL CART COUNT
  ============================================================ */

  useEffect(() => {
    syncAllCartCounts();
  }, [syncAllCartCounts]);

  /* ============================================================
     REAL-TIME CART COUNT
     
     Har 5 second API refresh.
     Isse page reload ke bina latest count aayega.
     
     Agar aapka backend WebSocket deta hai to uske saath
     bhi integrate kiya ja sakta hai, lekin polling abhi
     immediately kaam karega.
  ============================================================ */



  /* ============================================================
     TAB HANDLER
  ============================================================ */

  const handleTabClick = (
    key
  ) => {
    if (key === "category") {
      setMenuOpen(true);
      setActiveTab(key);
      return;
    }

    if (key === "account") {
      setAccountMenuOpen(
        (prev) => !prev
      );

      setActiveTab(key);
      return;
    }

    setActiveTab(key);
  };

  /* ============================================================
     CATEGORY
  ============================================================ */

  const toggleCategory = (
    slug
  ) => {
    setExpandedCategory(
      (prev) =>
        prev === slug
          ? null
          : slug
    );

    setExpandedSub(null);
  };

  /* ============================================================
     SUB CATEGORY
  ============================================================ */

  const toggleSub = (
    slug
  ) => {
    setExpandedSub(
      (prev) =>
        prev === slug
          ? null
          : slug
    );

    setSearchText(
      (prev) => ({
        ...prev,
        [slug]: "",
      })
    );

    setTimeout(() => {
      searchInputRef.current?.focus();
    }, 100);
  };

  /* ============================================================
     MENU LINK
  ============================================================ */

  const handleMenuLinkClick = () => {
    setMenuOpen(false);
    setExpandedCategory(null);
    setExpandedSub(null);
  };

  /* ============================================================
     NAV ITEMS
     
     IMPORTANT:
     Fresh Cart count  = cartCount
     Coming Soon count = preCartCount
  ============================================================ */

  const navItems = [
    {
      key: "home",
      label: "Home",
      icon: "bi-house-door",
      fillIcon: "bi-house-door",
      path: "/home",
    },

    {
      key: "category",
      label: "Category",
      icon: "bi-grid",
      fillIcon: "bi-grid-fill",
    },
    // {
    //   key: "comingsoon",
    //   label: "Coming Soon",
    //   icon: "bi-tags",
    //   fillIcon: "bi-tags",
    //   path:"/coming-soon/items"
    // },
    {
      key: "Wishlist",
      label: "Wishlist",
      icon: "bi-heart",
      fillIcon: "bi-heart-fill",
      count: wishlistCount,
      path: "/wishlist",
    },

    /* ========================================================
       ACTUAL / FRESH CART
    ======================================================== */

    // {
    //   key: "FreshCart",
    //   label: "Cart",
    //   icon: "bi-cart",
    //   fillIcon: "bi-cart-fill",
    //   count: cartCount,
    //   path: "/cart?comingsoon=0",
    // },

    /* ========================================================
       COMING SOON / PRE CART
    ======================================================== */

    // {
    //   key: "ComingSoonCart",
    //   label: "Cart",
    //   icon: "bi-cart",
    //   fillIcon: "bi-cart-fill",
    //   count: preCartCount,
    //   path: "/cart?comingsoon=1",
    // },

    {
      key: "account",
      label: "My Account",
      icon: "bi-person",
      fillIcon: "bi-person",
    },
  ];

  /* ============================================================
     RENDER
  ============================================================ */

  return (
    <>
      {/* ======================================================
          MOBILE MENU
      ====================================================== */}

      <div
        className={`fixed top-0 left-0 h-full w-64 bg-white shadow-2xl z-[999]
        transition-transform duration-300
        ${
          menuOpen
            ? "translate-x-0"
            : "-translate-x-full"
        }`}
      >
        <div className="flex justify-between p-3 border-b">
          <h2
            style={{
              fontSize: "19px",
            }}
          >
            Menu
          </h2>

          <button
            type="button"
            onClick={() =>
              setMenuOpen(false)
            }
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        <ul
          className="p-4"
          style={{
            overflowY: "auto",
            height: "530px",
          }}
        >
          {categories.map(
            (cat) => (
              <li
                key={
                  cat.category_slug
                }
                className="border-b pb-2"
              >
                <div
                  className="flex justify-between items-center py-2 cursor-pointer"
                  onClick={() =>
                    toggleCategory(
                      cat.category_slug
                    )
                  }
                >
                  <span>
                    {
                      cat.category_name
                    }
                  </span>

                  <i
                    className={`bi ${
                      expandedCategory ===
                      cat.category_slug
                        ? "bi-chevron-up"
                        : "bi-chevron-down"
                    }`}
                  ></i>
                </div>

                {expandedCategory ===
                  cat.category_slug && (
                  <ul className="pl-4">
                    {(
                      cat.subcategories ||
                      []
                    )
                      .filter(
                        (sub) =>
                          sub.subcategory_name
                      )
                      .map(
                        (sub) => (
                          <li
                            key={
                              sub.subcategory_slug
                            }
                          >
                            <div
                              className="flex justify-between py-2 cursor-pointer"
                              onClick={(
                                event
                              ) => {
                                event.stopPropagation();

                                toggleSub(
                                  sub.subcategory_slug
                                );
                              }}
                            >
                              <span>
                                {
                                  sub.subcategory_name
                                }
                              </span>

                              {sub
                                .qualities
                                ?.length >
                                0 && (
                                <i
                                  className={`bi ${
                                    expandedSub ===
                                    sub.subcategory_slug
                                      ? "bi-chevron-up"
                                      : "bi-chevron-right"
                                  }`}
                                ></i>
                              )}
                            </div>

                            {expandedSub ===
                              sub.subcategory_slug && (
                              <ul className="pl-4">
                                {sub
                                  .qualities
                                  ?.length >
                                  10 && (
                                  <div className="search-menulist">
                                    <input
                                      ref={
                                        expandedSub ===
                                        sub.subcategory_slug
                                          ? searchInputRef
                                          : null
                                      }
                                      type="search"
                                      className="inputmenusearch"
                                      placeholder="Search..."
                                      value={
                                        searchText[
                                          sub.subcategory_slug
                                        ] ||
                                        ""
                                      }
                                      onChange={(
                                        event
                                      ) =>
                                        setSearchText(
                                          (
                                            prev
                                          ) => ({
                                            ...prev,
                                            [sub.subcategory_slug]:
                                              event
                                                .target
                                                .value,
                                          })
                                        )
                                      }
                                    />

                                    <span className="searicons">
                                      <i className="bi bi-search"></i>
                                    </span>
                                  </div>
                                )}

                                {(
                                  sub.qualities ||
                                  []
                                )
                                  .filter(
                                    (
                                      quality
                                    ) =>
                                      quality.quality_name
                                        ?.toLowerCase()
                                        .includes(
                                          (
                                            searchText[
                                              sub.subcategory_slug
                                            ] ||
                                            ""
                                          ).toLowerCase()
                                        )
                                  )
                                  .map(
                                    (
                                      quality
                                    ) => (
                                      <li
                                        key={
                                          quality.quality_action_link
                                        }
                                        className="py-1"
                                      >
                                        <Link
                                          to={getProductUrl(
                                            quality?.quality_action_link
                                          )}
                                          onClick={
                                            handleMenuLinkClick
                                          }
                                        >
                                          {
                                            quality.quality_name
                                          }
                                        </Link>
                                      </li>
                                    )
                                  )}
                              </ul>
                            )}
                          </li>
                        )
                      )}
                  </ul>
                )}
              </li>
            )
          )}
        </ul>
      </div>

      {/* ======================================================
          OVERLAY
      ====================================================== */}

      {menuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-[998]"
          onClick={() =>
            setMenuOpen(false)
          }
        ></div>
      )}

      {/* ======================================================
          BOTTOM BAR
      ====================================================== */}

      <div className="bottom-panel fixed bottom-0 w-full bg-white shadow-lg z-50">
        <ul className="flex justify-around items-center relative">
          {navItems.map(
            (item) => (
              <li
                key={item.key}
                className={`flex flex-col items-center relative ${
                  item.key ===
                    "FreshCart" ||
                  item.key ===
                    "ComingSoonCart"
                    ? "cart-disable"
                    : ""
                }`}
                onClick={() =>
                  handleTabClick(
                    item.key
                  )
                }
                ref={
                  item.key ===
                  "account"
                    ? accountRef
                    : null
                }
              >
                {/* =================================================
                    LINK
                ================================================= */}

                {item.path  ? (
                  <Link
                    to={item.path}
                    className="flex flex-col items-center relative"
                  >
                    <div className="icon mb-1 relative">
                      <i
                        className={`bi ${
                          activeTab ===
                          item.key
                            ? item.fillIcon
                            : item.icon
                        } text-lg`}
                      ></i>

                      {"count" in
                        item && (
                        <span className="absolute -top-1 -right-2 bg-red-500 text-white text-[10px] font-bold rounded-full px-1.5 py-0.5 cart-disablebox">
                          {item.count}
                        </span>
                      )}
                    </div>

                    <span className="text-xs font-medium">
                      {item.label}
                    </span>
                  </Link>
                ) : (
                  <div className="flex flex-col items-center relative cursor-pointer">
                    <div className="icon mb-1 relative">
                      <i
                        className={`bi ${
                          activeTab ===
                          item.key
                            ? item.fillIcon
                            : item.icon
                        } text-lg`}
                      ></i>

                      {"count" in
                        item && (
                        <span className="absolute -top-1 -right-2 bg-red-500 text-white text-[10px] font-bold rounded-full px-1.5 py-0.5 cart-disablebox">
                          {item.count}
                        </span>
                      )}
                    </div>

                    <span className="text-xs font-medium">
                      {item.label}
                    </span>
                  </div>
                )}

                {/* =================================================
                    ACCOUNT DROPDOWN
                ================================================= */}


                {item.key === "account" && accountMenuOpen && (
                  <div className="account-dropdown">
                    <ul className="account-menu-list">
                      {isLoggedIn ? (
                        <>
                          {/* My Account */}
                          <li className="account-menu-item">
                            <Link
                              to="/account/orders"
                              className="account-menu-link"
                              onClick={() => setAccountMenuOpen(false)}
                            >
                              <i className="bi bi-person-circle account-menu-icon" />
                              <span>My Account</span>
                            </Link>
                          </li>

                          {/* QR Order */}
                          {showQrCodeScan && (
                            <li className="account-menu-item">
                              <Link
                                to="/scanner"
                                className="account-menu-link"
                                onClick={() => setAccountMenuOpen(false)}
                              >
                                <i className="bi bi-qr-code-scan account-menu-icon" />
                                <span>QR Order</span>
                              </Link>
                            </li>
                          )}

                          {/* Pre Order */}
                          {showQrCodeScan && (
                            <li className="account-menu-item">
                              <Link
                                to="/cart?comingsoon=1"
                                className="account-menu-link"
                                onClick={() => setAccountMenuOpen(false)}
                              >
                                <i className="bi bi-bag-check account-menu-icon cartanimated-icon2" />
                                <span>Pre Order</span>
                              </Link>
                            </li>
                          )}

                          {/* Logout */}
                          <li className="account-menu-item">
                            <button
                              type="button"
                              onClick={handleLogout}
                              className="account-menu-link account-logout"
                            >
                              <i className="bi bi-box-arrow-right account-menu-icon" />
                              <span>LOGOUT</span>
                            </button>
                          </li>
                        </>
                      ) : (
                        /* Sign In */
                        <li className="account-menu-item">
                          <Link
                            to="/"
                            className="account-menu-link"
                            onClick={() => setAccountMenuOpen(false)}
                          >
                            <i className="bi bi-box-arrow-in-right account-menu-icon" />
                            <span>Sign In</span>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                )}


              </li>
            )
          )}
        </ul>
      </div>
    </>
  );
}

export default BottomPanel;
